export default __webpack_public_path__ + "static/media/schnellbahn-neubauprojekte-wien.41aa75f1.svg";